"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60687],{

/***/ 222056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(944912);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(252661);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_HEIGHT = {
  m: 24,
  l: 32
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s12};
  padding-right: ${(p) => p.theme.spacing.s12};
  background-color: ${(p) => p.theme.colors.white};
  height: ${(p) => MAPPING_HEIGHT[p.size]}px;
  border-radius: 1.5rem;
  border: ${(p) => p.theme.borderWeight.m} solid
    ${(p) => p.theme.colors.disable};
  ${(p) => p.disabled ? "cursor: not-allowed;" : `
  `}
`;
const Chip = (_a) => {
  var _b = _a, {
    content,
    size = "m",
    closable,
    closeIcon,
    disabled = false,
    onClose = () => {
    },
    onClick
  } = _b, props = __objRest(_b, [
    "content",
    "size",
    "closable",
    "closeIcon",
    "disabled",
    "onClose",
    "onClick"
  ]);
  const getColorCloseIcon = () => {
    var _a2;
    if (!closable || closeIcon || (0,_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .hasColoredIcon */ .e)(closeIcon))
      return void 0;
    if (disabled)
      return "disabled";
    if (!((_a2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _a2.color))
      return "placeholder";
    return closeIcon.props.color;
  };
  const renderClose = () => {
    var _a2, _b2;
    if (!closable)
      return null;
    return closeIcon ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(closeIcon, {
      size: !((_a2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _a2.size) ? 16 : closeIcon.props.size,
      color: getColorCloseIcon(),
      onClick: (e) => !disabled && onClose(e),
      style: __spreadProps(__spreadValues({}, (_b2 = closeIcon == null ? void 0 : closeIcon.props) == null ? void 0 : _b2.style), {
        cursor: disabled ? "not-allowed" : "pointer"
      })
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .DeleteCircleFilled */ .N, {
      color: disabled ? "disable" : "placeholder",
      size: 16,
      style: { cursor: disabled ? "not-allowed" : "pointer" },
      onClick: (e) => !disabled && onClose(e)
    });
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    onClick: () => {
      !disabled && onClick && onClick();
    },
    size,
    disabled
  }, props), size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    level: 1,
    weight: "regular",
    line: 1,
    color: disabled ? "disable" : "textPrimary",
    marginRight: closable ? "s8" : void 0
  }, content), renderClose()) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Caption */ .YS, {
    level: 1,
    weight: "regular",
    line: 1,
    color: disabled ? "disable" : "textPrimary",
    marginRight: closable ? "s4" : void 0
  }, content), renderClose()));
};




/***/ }),

/***/ 944912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ hasColoredIcon; }
/* harmony export */ });
const hasColoredIcon = (ele) => {
  var _a, _b;
  if (!ele)
    return false;
  return (_b = (_a = ele == null ? void 0 : ele.type) == null ? void 0 : _a.name) == null ? void 0 : _b.endsWith("Colored");
};




/***/ }),

/***/ 241291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SelectionOption; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285212);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4247);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_ICON_ACTIVE_SIZE = {
  [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs]: 14,
  [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.s */ .mO.s]: 14
};
const MAPPING_ACTIVE_BORDER = {
  [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.xs */ .mO.xs]: "0px 24px 24px 0px",
  [_teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.s */ .mO.s]: "0px 24px 24px 0px"
};
const SelectionOption = (_a) => {
  var _b = _a, {
    children,
    block = true,
    isActive = false,
    onClick,
    iconActiveSize = _teko_types_ds__WEBPACK_IMPORTED_MODULE_1__/* .SizeEnum.m */ .mO.m,
    disabled = false
  } = _b, rest = __objRest(_b, [
    "children",
    "block",
    "isActive",
    "onClick",
    "iconActiveSize",
    "disabled"
  ]);
  const handleClick = () => {
    if (!disabled && typeof onClick === "function") {
      onClick(!isActive);
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    isActive,
    disabled,
    block,
    onClick: handleClick
  }, rest), typeof children === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    style: { textAlign: "center" },
    level: 1
  }, children) : children, !disabled && isActive && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActiveBorder, {
    iconActiveSize
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Checked, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .CheckOutlined */ .b, {
    size: MAPPING_ICON_ACTIVE_SIZE[iconActiveSize] || 20,
    color: "#ffffff"
  }))));
};
const getBorderColor = (props) => {
  return props.theme && props.isActive ? props.theme.colors.primary500 : "#e0e0e0";
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: #fff;
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  ${props.block ? "width: 100%;" : ""}

  ${props.disabled ? `
    & > * {
      opacity: 0.4 !important;
    }
  ` : ""}
  &:hover {
    background: ${props.isActive || props.disabled ? "" : "#f3f3f3"} ;
  }
`);
const ActiveBorder = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ iconActiveSize, theme }) => `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${MAPPING_ACTIVE_BORDER[iconActiveSize] || "0px 36px 36px 0px"};
  border-color: transparent ${theme == null ? void 0 : theme.colors.primary500} transparent transparent;
`);
const Checked = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].span`
  display: flex;
  position: absolute;
  top: -1px;
  right: -1px;
  z-index: 0;
`;




/***/ }),

/***/ 68018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ VerticalFilter; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Chip/Chip.es.js
var Chip_es = __webpack_require__(222056);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DeleteCircleColored.es.js
var DeleteCircleColored_es = __webpack_require__(379126);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Checkbox/Checkbox.es.js
var Checkbox_es = __webpack_require__(115869);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/UpOutlined.es.js
var UpOutlined_es = __webpack_require__(994734);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/VerticalFilter/CategoriesFilter.es.js





const DEFAULT_DISPLAY_FILTERS = 4;
const CategoriesFilter = (props) => {
  const { filterName, filterOptions, activeOptions, onClickCategoryOption } = props;
  const [numberOfDisplayFilters, setNumberOfDisplayFilters] = (0,react.useState)(DEFAULT_DISPLAY_FILTERS);
  const activeCats = new Set(activeOptions.map(({ code }) => code));
  const checkChildren = (root) => {
    if (!root.children.length)
      return;
    root.children.forEach((child) => {
      if (!!child.code && !!root.code && activeCats.has(root.code)) {
        activeCats.add(child.code);
      }
      checkChildren(child);
    });
  };
  filterOptions.forEach(checkChildren);
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    height: "1.5rem"
  }, /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    level: 4,
    weight: "medium"
  }, filterName)), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: "column",
    gap: "s4",
    style: { padding: "2px 0px" }
  }, filterOptions.slice(0, numberOfDisplayFilters).map((option, index) => {
    return /* @__PURE__ */ react.createElement(Filter, {
      key: `${index}${option.id}${option.code}`,
      option,
      onClickCategoryOption,
      activeCats
    });
  })), filterOptions.length > DEFAULT_DISPLAY_FILTERS && /* @__PURE__ */ react.createElement(ViewAll, {
    onClick: () => setNumberOfDisplayFilters(numberOfDisplayFilters > DEFAULT_DISPLAY_FILTERS ? DEFAULT_DISPLAY_FILTERS : filterOptions.length)
  }, (0,i18n_es.t)(numberOfDisplayFilters > DEFAULT_DISPLAY_FILTERS ? "\u1EA8n b\u1EDBt" : "Xem th\xEAm")));
};
const Filter = (props) => {
  const { option, activeCats, onClickCategoryOption } = props;
  const [showChildren, setShowChildren] = (0,react.useState)(false);
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    justify: "space-between",
    width: "100%",
    style: { padding: "2px 0" }
  }, /* @__PURE__ */ react.createElement(Checkbox_es/* Checkbox */.X, {
    checked: !!option.code && activeCats.has(option.code),
    onChange: (_check) => onClickCategoryOption == null ? void 0 : onClickCategoryOption(option)
  }, option.level === 1 ? /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    line: 1
  }, option.name) : option.level === 2 ? option.name : /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    line: 1,
    level: 1
  }, option.name)), !!option.children.length && /* @__PURE__ */ react.createElement(react.Fragment, null, showChildren ? /* @__PURE__ */ react.createElement(UpOutlined_es/* UpOutlined */.X, {
    onClick: () => setShowChildren((prev) => !prev)
  }) : /* @__PURE__ */ react.createElement(DownOutlined_es/* DownOutlined */.T, {
    onClick: () => setShowChildren((prev) => !prev)
  }))), !!option.children.length && showChildren && /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: "column",
    gap: "s4",
    paddingLeft: "s24",
    width: "100%"
  }, option.children.map((child, index) => {
    return /* @__PURE__ */ react.createElement(Filter, {
      key: `${index}${child.id}${child.code}`,
      option: child,
      onClickCategoryOption,
      activeCats
    });
  })));
};
const ViewAll = emotion_styled_browser_esm["default"].span(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.link500};
  cursor: pointer;
  font-size: 0.75rem;
  margin-left: 1.7rem;
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Popover/Tooltip.es.js
var Tooltip_es = __webpack_require__(386877);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/index.es.js
var helpers_index_es = __webpack_require__(649771);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/VerticalFilter/FilterCollapse.es.js






const FilterCheckbox = ({
  isActive,
  onClickOption,
  option,
  collapseContentWidth,
  collapseContentColumn,
  setCollapseContentColumn
}) => {
  const ref = (0,react.useRef)(null);
  (0,react.useLayoutEffect)(() => {
    if (ref.current && collapseContentWidth) {
      const checkboxSize = ref.current.offsetWidth + 28;
      if (checkboxSize > collapseContentWidth / 2 && collapseContentColumn === 2) {
        setCollapseContentColumn(1);
      }
    }
  }, [setCollapseContentColumn, collapseContentWidth, collapseContentColumn]);
  return /* @__PURE__ */ react.createElement(Checkbox_es/* Checkbox */.X, {
    checked: isActive,
    onChange: (_checked) => {
      onClickOption == null ? void 0 : onClickOption(option);
    },
    paddingRight: "s8"
  }, /* @__PURE__ */ react.createElement(Tooltip_es/* Tooltip */.u, {
    title: option.optionName || "",
    triggerHover: true
  }, /* @__PURE__ */ react.createElement("div", {
    ref
  }, option.optionName || "")));
};
const FilterCollapse = ({
  filter,
  active = false,
  activeOptions = [],
  onClickOption
}) => {
  const [show, setShow] = (0,react.useState)(active);
  const [max, setMax] = (0,react.useState)(4);
  const checkboxsRef = (0,react.useRef)(null);
  const [collapseContentWidth, setCollapseContentWidth] = (0,react.useState)(0);
  const [collapseContentColumn, setCollapseContentColumn] = (0,react.useState)(2);
  const { options } = filter;
  (0,react.useLayoutEffect)(() => {
    if (checkboxsRef.current) {
      setCollapseContentWidth(checkboxsRef.current.offsetWidth);
    }
  }, [checkboxsRef]);
  if (!(options == null ? void 0 : options.length))
    return null;
  const precomputeColumnLayout = (options2) => {
    const maxWidth = Math.max(...options2.map((option) => (0,helpers_index_es/* estimateTextWidth */.b)(option.optionName, 13)));
    const columnWidth = maxWidth + 28;
    return columnWidth > 163 / 2 ? 1 : 2;
  };
  const precomputedNumberOfColumns = typeof window === "undefined" ? precomputeColumnLayout(options.slice(0, 4)) : 0;
  return /* @__PURE__ */ react.createElement(Collapse, null, /* @__PURE__ */ react.createElement(CollapseHeader, {
    onClick: () => setShow(!show)
  }, /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    level: 4,
    weight: "medium"
  }, filter.name), /* @__PURE__ */ react.createElement(StyledDownOutlined, {
    className: show ? "active" : "",
    color: "textPrimary"
  })), /* @__PURE__ */ react.createElement(CollapseContent, {
    className: show ? "active" : "",
    ref: checkboxsRef
  }, /* @__PURE__ */ react.createElement(StyledFlex, {
    direction: "row"
  }, options.slice(0, max).map((option, index) => {
    const isActive = activeOptions.filter((curr) => curr.optionId === option.optionId).length > 0;
    const numberOfColumns = typeof window === "undefined" ? precomputedNumberOfColumns : collapseContentColumn;
    return /* @__PURE__ */ react.createElement("div", {
      key: index,
      style: {
        minWidth: numberOfColumns === 2 ? "50%" : "100%"
      }
    }, /* @__PURE__ */ react.createElement(FilterCheckbox, {
      isActive,
      onClickOption,
      option,
      collapseContentWidth,
      collapseContentColumn: numberOfColumns,
      setCollapseContentColumn
    }));
  })), max < options.length && /* @__PURE__ */ react.createElement(FilterCollapse_es_ViewAll, {
    onClick: () => setMax(options.length)
  }, (0,i18n_es.t)("Xem th\xEAm"))));
};
const FilterCollapse_es_ViewAll = emotion_styled_browser_esm["default"].span(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.link500};
  cursor: pointer;
  font-size: 0.75rem;
  margin-left: 1.7rem;
`);
const StyledDownOutlined = (0,emotion_styled_browser_esm["default"])(DownOutlined_es/* DownOutlined */.T)`
  transition: 0.2s;
  &.active {
    transform: rotate(180deg);
  }
`;
const Collapse = emotion_styled_browser_esm["default"].div``;
const CollapseHeader = emotion_styled_browser_esm["default"].div`
  display: flex;
  justify-content: space-between;
  height: 1.5rem;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;
const CollapseContent = emotion_styled_browser_esm["default"].div(({ theme }) => `
  height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 0.25rem;
  &.active {
    margin-top: ${theme == null ? void 0 : theme.spacing.s12};
    height: auto;
  }
`);
const StyledFlex = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)`
  flex-wrap: wrap;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/PriceFilter/PriceFilter.es.js
var PriceFilter_es = __webpack_require__(605078);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/VerticalFilter/VerticalFilter.es.js








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const VerticalFilter = ({
  filters = [],
  onClickOption,
  activeOptions = [],
  clearFilterLink,
  filterPrice,
  onClearFilter,
  categoriesFilter
}) => {
  if (!filters.length && !filterPrice)
    return null;
  return /* @__PURE__ */ react.createElement(Wrapper, null, (!!activeOptions.length || !!(categoriesFilter == null ? void 0 : categoriesFilter.activeOptions.length)) && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    level: 4,
    weight: "medium",
    marginBottom: "s12"
  }, (0,i18n_es.t)("B\u1ED9 l\u1ECDc \u0111\xE3 d\xF9ng")), /* @__PURE__ */ react.createElement(ActiveOptionsWrapper, null, activeOptions.map((option, index) => /* @__PURE__ */ react.createElement(Chip_es/* Chip */.A, {
    key: index,
    content: option.optionName || "",
    closable: true,
    onClick: () => onClickOption == null ? void 0 : onClickOption(option),
    onClose: () => onClickOption == null ? void 0 : onClickOption(option),
    closeIcon: /* @__PURE__ */ react.createElement(DeleteCircleColored_es/* DeleteCircleColored */.H, null),
    style: { cursor: "pointer" }
  })), categoriesFilter == null ? void 0 : categoriesFilter.activeOptions.map((cat, index) => /* @__PURE__ */ react.createElement(Chip_es/* Chip */.A, {
    key: index,
    content: cat.name || "",
    closable: true,
    onClick: () => {
      var _a;
      return cat.code ? (_a = categoriesFilter == null ? void 0 : categoriesFilter.onRemoveCategory) == null ? void 0 : _a.call(categoriesFilter, cat.code) : null;
    },
    onClose: () => {
      var _a;
      return cat.code ? (_a = categoriesFilter == null ? void 0 : categoriesFilter.onRemoveCategory) == null ? void 0 : _a.call(categoriesFilter, cat.code) : null;
    },
    closeIcon: /* @__PURE__ */ react.createElement(DeleteCircleColored_es/* DeleteCircleColored */.H, null),
    style: { cursor: "pointer" }
  }))), /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    onClick: (e) => {
      if (onClearFilter) {
        e.preventDefault();
        onClearFilter == null ? void 0 : onClearFilter();
      }
    },
    style: {
      cursor: onClearFilter || clearFilterLink ? "pointer" : "default"
    }
  }, /* @__PURE__ */ react.createElement(CustomLink_es/* CustomLink */.x, __spreadValues({}, clearFilterLink), /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    weight: "regular",
    color: "error500"
  }, (0,i18n_es.t)("X\xF3a b\u1ED9 l\u1ECDc"))), /* @__PURE__ */ react.createElement(Divider_es/* Divider */.i, {
    color: "border",
    gap: 12
  }))), !!categoriesFilter && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(CategoriesFilter, __spreadValues({}, categoriesFilter)), /* @__PURE__ */ react.createElement(Divider_es/* Divider */.i, {
    color: "border",
    gap: 12
  })), filterPrice && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    level: 4,
    weight: "medium",
    marginBottom: "s8"
  }, (0,i18n_es.t)("Kho\u1EA3ng gi\xE1")), /* @__PURE__ */ react.createElement(PriceFilter_es/* PriceFilter */.W, {
    max: filterPrice.max,
    min: filterPrice.min,
    step: filterPrice.step,
    value: filterPrice.value,
    onFilter: filterPrice.onFilter
  }), /* @__PURE__ */ react.createElement(Divider_es/* Divider */.i, {
    color: "border",
    gap: 12
  })), filters.map((filter, index) => {
    return /* @__PURE__ */ react.createElement(react.Fragment, {
      key: index
    }, /* @__PURE__ */ react.createElement(FilterCollapse, {
      onClickOption,
      active: index < 6,
      filter,
      activeOptions
    }), index < filters.length - 1 && /* @__PURE__ */ react.createElement(Divider_es/* Divider */.i, {
      color: "border",
      gap: 12
    }));
  }));
};
const Wrapper = emotion_styled_browser_esm["default"].div(({ theme }) => `
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  padding: ${theme == null ? void 0 : theme.spacing.s12};
  background: ${theme == null ? void 0 : theme.colors.white};
  display: flex;
  flex-direction: column;
`);
const ActiveOptionsWrapper = emotion_styled_browser_esm["default"].div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
`;




/***/ })

}]);